import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton/FlatButton';
import languagesHelper from 'helpers/languages';
import translate from 'components/hoc/translate';

const styles = {
    content: {
        margin: '20px 0',
    },
    item: {
        height: '75px',
        margin: '20px 20px 0 0',
    },
    list: {
        margin: '20px',
        display: 'flex',
        flexBasis: '100%',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
};

const LocaleDialog = (props) => {
    const {
        handleCloseDialog,
        handleChangeData,
        list,
        open,
        translate,
        disabled,
    } = props;

    const translatedLabel = (value) => {
        const language = languagesHelper.getLabel(value);

        return translate(`languages.${ language.toLowerCase() }`);
    };

    const renderListItem = (item, index) => {
        const label = translatedLabel(item);

        return (
            <FlatButton
                backgroundColor='rgba(220, 247, 251, 1)'
                hoverColor='rgba(184, 215, 220, 1)'
                key={ `${ item }_${ index }` }
                label={ label }
                labelPosition='after'
                onClick={ () => {
                    handleChangeData(item);
                } }
                style={ styles.item }
            />
        );
    };

    const actions = [
        <FlatButton
            keyboardFocused={ true }
            key='cancel-locale'
            label={ translate('actions.cancel') }
            onTouchTap={ () => {
                handleCloseDialog();
            } }
            primary={ true }
        />,
    ];

    return (
        <Dialog
            title={ translate('forms.localisation.required.title') }
            actions={ actions }
            modal={ false }
            open={ open }
            overlayStyle={ {
                backgroundColor: 'rgba(237, 236, 236, 0.6)',
            } }
            autoScrollBodyContent={ true }
            onRequestClose={ () => {
                handleCloseDialog();
            } }
        >
            { disabled ?
                <div style={ styles.content }>
                    { translate('forms.localisation.required.description') }
                </div>
                :
                <div style={ styles.list }>
                    {
                        list.map((item, index) => {
                            return renderListItem(item, index);
                        })
                    }
                </div>
            }
        </Dialog>
    );
};

LocaleDialog.propTypes = {
    disabled: PropTypes.bool.isRequired,
    handleChangeData: PropTypes.func.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    list: PropTypes.array,
    open: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(LocaleDialog);



// WEBPACK FOOTER //
// ./src/components/form/localisation/dialog/LocaleDialog.js